module.exports = __webpack_public_path__ + "img/mw.19e277b7.svg";